import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route, useNavigate, useLocation, Link, Navigate } from "react-router-dom";
import CvDashboard from "./cv/pages/CvDashboard";
import AddStaffing from "./cv/pages/AddStaffing";
import ConfigurationPosition from "./cv/pages/Configuration-position";
import JobDescription from "./cv/pages/JobDescription";
import AdminLogin from "./cv/pages/AdminLogin";
import ProtectedRoute from "./cv/compenents/ProtectedRoute";
import { AuthProvider, useAuth } from "./cv/context/AuthContext";
import "./App.css";
import ProposalPage from "./proposal/pages/ProposalPage";
import ChangePassword from "./cv/pages/ChangePassword";
import ProposalLogin from "./proposal/pages/ProposalLogin";
import ProposalChangePassword from "./proposal/pages/ProposalChangePassword";

const isProposalAuthenticated = () => !!sessionStorage.getItem("proposal_token");

function ProposalProtectedRoute({ children }) {
  return isProposalAuthenticated() ? children : <Navigate to="/proposal/login" />;
}

function LandingPage() {
  const navigate = useNavigate();
  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700;900&family=DM+Sans:wght@300;400;500;600&display=swap');
        *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
        .landing-root {
          min-height: 100vh; background: #0a0f1e;
          display: flex; flex-direction: column; align-items: center; justify-content: center;
          font-family: 'DM Sans', sans-serif; position: relative; overflow: hidden; padding: 40px 24px;
        }
        .landing-root::before {
          content: ''; position: fixed; top: -200px; left: -200px; width: 600px; height: 600px;
          background: radial-gradient(circle, rgba(0,70,135,0.35) 0%, transparent 65%);
          border-radius: 50%; pointer-events: none; animation: driftA 12s ease-in-out infinite alternate;
        }
        .landing-root::after {
          content: ''; position: fixed; bottom: -150px; right: -150px; width: 500px; height: 500px;
          background: radial-gradient(circle, rgba(16,185,129,0.2) 0%, transparent 65%);
          border-radius: 50%; pointer-events: none; animation: driftB 15s ease-in-out infinite alternate;
        }
        @keyframes driftA { from { transform: translate(0,0) scale(1); } to { transform: translate(80px,60px) scale(1.1); } }
        @keyframes driftB { from { transform: translate(0,0) scale(1); } to { transform: translate(-60px,-40px) scale(1.15); } }
        .grid-overlay {
          position: fixed; inset: 0;
          background-image: linear-gradient(rgba(255,255,255,0.025) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.025) 1px, transparent 1px);
          background-size: 60px 60px; pointer-events: none; z-index: 0;
        }
        .landing-inner { position: relative; z-index: 1; display: flex; flex-direction: column; align-items: center; gap: 0; }
        .landing-badge {
          display: inline-flex; align-items: center; gap: 8px;
          background: rgba(0,70,135,0.25); border: 1px solid rgba(0,100,200,0.4);
          color: #7db8f7; font-size: 11px; font-weight: 600; letter-spacing: 0.12em; text-transform: uppercase;
          padding: 6px 16px; border-radius: 100px; margin-bottom: 32px; animation: fadeDown 0.6s ease both;
        }
        .badge-dot { width: 6px; height: 6px; background: #4ade80; border-radius: 50%; box-shadow: 0 0 8px #4ade80; animation: pulse 2s ease infinite; }
        @keyframes pulse { 0%,100% { opacity:1; transform:scale(1); } 50% { opacity:0.6; transform:scale(1.4); } }
        .landing-title {
          font-family: 'Playfair Display', serif; font-size: clamp(42px,6vw,72px); font-weight: 900;
          color: #ffffff; line-height: 1.1; text-align: center; margin-bottom: 16px;
          animation: fadeDown 0.6s 0.1s ease both; letter-spacing: -1px;
        }
        .landing-title span { background: linear-gradient(135deg,#60a5fa,#34d399); -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text; }
        @keyframes fadeDown { from { opacity:0; transform:translateY(-16px); } to { opacity:1; transform:translateY(0); } }
        .portal-grid { display: grid; grid-template-columns: repeat(2,1fr); gap: 24px; width: 100%; max-width: 720px; animation: fadeUp 0.7s 0.3s ease both; }
        @keyframes fadeUp { from { opacity:0; transform:translateY(24px); } to { opacity:1; transform:translateY(0); } }
        .portal-card {
          position: relative; background: rgba(255,255,255,0.04); border: 1px solid rgba(255,255,255,0.08);
          border-radius: 24px; padding: 40px 32px 36px; cursor: pointer;
          transition: all 0.35s cubic-bezier(0.16,1,0.3,1); overflow: hidden;
          display: flex; flex-direction: column; align-items: flex-start; gap: 0; text-decoration: none;
        }
        .portal-card::before { content: ''; position: absolute; inset: 0; border-radius: 24px; opacity: 0; transition: opacity 0.35s ease; }
        .portal-card.cv::before       { background: linear-gradient(135deg,rgba(0,70,135,0.3),rgba(0,100,200,0.15)); }
        .portal-card.proposal::before { background: linear-gradient(135deg,rgba(5,150,105,0.3),rgba(16,185,129,0.15)); }
        .portal-card:hover { transform:translateY(-6px) scale(1.02); border-color:rgba(255,255,255,0.2); box-shadow:0 32px 64px rgba(0,0,0,0.4); }
        .portal-card:hover::before { opacity:1; }
        .portal-card::after { content:''; position:absolute; top:0; left:20%; right:20%; height:1px; border-radius:100px; opacity:0; transition:opacity 0.35s ease; }
        .portal-card.cv::after       { background:linear-gradient(90deg,transparent,#60a5fa,transparent); }
        .portal-card.proposal::after { background:linear-gradient(90deg,transparent,#34d399,transparent); }
        .portal-card:hover::after { opacity:1; }
        .card-icon-wrap { width:56px; height:56px; border-radius:16px; display:flex; align-items:center; justify-content:center; font-size:26px; margin-bottom:24px; position:relative; z-index:1; transition:transform 0.3s ease; }
        .portal-card.cv .card-icon-wrap       { background:rgba(0,70,135,0.35); }
        .portal-card.proposal .card-icon-wrap { background:rgba(5,150,105,0.35); }
        .portal-card:hover .card-icon-wrap { transform:scale(1.1) rotate(-4deg); }
        .card-name { font-family:'Playfair Display',serif; font-size:24px; font-weight:700; color:#ffffff; margin-bottom:10px; position:relative; z-index:1; line-height:1.2; }
        .landing-footer { margin-top:52px; font-size:12px; color:rgba(255,255,255,0.2); text-align:center; animation:fadeUp 0.7s 0.5s ease both; font-weight:300; letter-spacing:0.04em; }
        @media (max-width:600px) { .portal-grid { grid-template-columns:1fr; max-width:360px; } .landing-title { font-size:38px; } }
      `}</style>
      <div className="landing-root">
        <div className="grid-overlay" />
        <div className="landing-inner">
          <div className="landing-badge"><span className="badge-dot" />UHF Solutions</div>
          <h1 className="landing-title"><span>Portal Hub</span></h1>
          <div className="portal-grid">
            <div className="portal-card cv" onClick={() => navigate("/cv/login")}>
              <div className="card-icon-wrap">🏢</div>
              <div className="card-name">CV &amp; Staffing Portal</div>
            </div>
            <div className="portal-card proposal" onClick={() => navigate("/proposal/login")}>
              <div className="card-icon-wrap">📄</div>
              <div className="card-name">Proposal Generator</div>
            </div>
          </div>
          <div className="landing-footer">© {new Date().getFullYear()} UHF Solutions</div>
        </div>
      </div>
    </>
  );
}

function CvDashboardLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const { logout } = useAuth();
  const [collapsed, setCollapsed] = useState(false);
  const [openConfig, setOpenConfig] = useState(location.pathname.startsWith("/cv/configuration"));

  const handleLogout = () => { logout(); navigate("/cv/login"); };
  const isActive = (path) => location.pathname === path;

  return (
    <div className="app-wrapper">
      <aside className={`sidebar ${collapsed ? "collapsed" : ""}`}>
        <button className="sidebar-toggle" onClick={() => setCollapsed(!collapsed)} title={collapsed ? "Open Menu" : "Close Menu"}>
          {collapsed ? "➡" : "⬅"}
        </button>
        <div className="sidebar-header">
          <h2><span className="header-text">HR Portal</span></h2>
        </div>
        <nav className="sidebar-nav">
          <Link to="/cv" className={`nav-item ${isActive("/cv") ? "active" : ""}`}>
            <span className="nav-icon">📄</span>
            <span className="nav-text">CV Dashboard</span>
          </Link>
          <Link to="/cv/add-staffing" className={`nav-item ${isActive("/cv/add-staffing") ? "active" : ""}`}>
            <span className="nav-icon">➕</span>
            <span className="nav-text">Add Staffing</span>
          </Link>
          <Link to="/cv/job-description" className={`nav-item sub ${isActive("/cv/job-description") ? "active" : ""}`}>
            <span className="nav-icon">💼</span>
            <span className="nav-text">Job Description</span>
          </Link>
          <div
            className={`nav-item ${location.pathname.startsWith("/cv/configuration") ? "active" : ""}`}
            onClick={() => setOpenConfig(!openConfig)}
            style={{ cursor: "pointer" }}
          >
            <span className="nav-icon">⚙️</span>
            <span className="nav-text">Configuration</span>
            <span className="nav-arrow">{openConfig ? "▾" : "▸"}</span>
          </div>
          {openConfig && (
            <div className="nav-submenu">
              <Link to="/cv/configuration-position" className={`nav-item sub ${isActive("/cv/configuration-position") ? "active" : ""}`}>
                <span className="nav-text">Position</span>
              </Link>
            </div>
          )}
          <Link to="/cv/change-password" className={`nav-item ${isActive("/cv/change-password") ? "active" : ""}`}>
            <span className="nav-icon">🔑</span>
            <span className="nav-text">Change Password</span>
          </Link>
        </nav>
      </aside>
      <div className={`main-wrapper ${collapsed ? "expanded" : ""}`}>
        <header className="topbar">
          <span className="topbar-title">HR Portal</span>
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <button className="logout-btn" onClick={() => navigate("/")} style={{ background: "linear-gradient(180deg,#334155 0%,#1e293b 100%)" }}>
              🏠 Portal Hub
            </button>
            <button className="logout-btn" onClick={handleLogout}>🚪 Logout</button>
          </div>
        </header>
        <main className="main-content">
          <Routes>
            <Route path="/"                      element={<ProtectedRoute><CvDashboard /></ProtectedRoute>} />
            <Route path="/add-staffing"           element={<ProtectedRoute><AddStaffing /></ProtectedRoute>} />
            <Route path="/configuration-position" element={<ProtectedRoute><ConfigurationPosition /></ProtectedRoute>} />
            <Route path="/job-description"        element={<ProtectedRoute><JobDescription /></ProtectedRoute>} />
            <Route path="/change-password"        element={<ProtectedRoute><ChangePassword /></ProtectedRoute>} />
          </Routes>
        </main>
      </div>
    </div>
  );
}

function ProposalDashboardLayout({ children }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);

  const handleLogout = () => {
    sessionStorage.removeItem("proposal_token");
    navigate("/proposal/login");
  };

  const isActive = (path) => location.pathname === path;

  return (
    <div className="app-wrapper">
      <aside className={`sidebar ${collapsed ? "collapsed" : ""}`}>
        <button className="sidebar-toggle" onClick={() => setCollapsed(!collapsed)} title={collapsed ? "Open Menu" : "Close Menu"}>
          {collapsed ? "➡" : "⬅"}
        </button>
        <div className="sidebar-header">
          <h2><span className="header-text">Proposal</span></h2>
        </div>
        <nav className="sidebar-nav">
          <Link to="/proposal" className={`nav-item ${isActive("/proposal") ? "active" : ""}`}>
            <span className="nav-icon">📄</span>
            <span className="nav-text">Proposal Generator</span>
          </Link>
          <Link to="/proposal/change-password" className={`nav-item ${isActive("/proposal/change-password") ? "active" : ""}`}>
            <span className="nav-icon">🔑</span>
            <span className="nav-text">Change Password</span>
          </Link>
        </nav>
      </aside>

      <div className={`main-wrapper ${collapsed ? "expanded" : ""}`}>
        <header className="topbar">
          <span className="topbar-title">Proposal Generator</span>
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <button className="logout-btn" onClick={() => navigate("/")} style={{ background: "linear-gradient(180deg,#334155 0%,#1e293b 100%)" }}>
              🏠 Portal Hub
            </button>
            <button className="logout-btn" onClick={handleLogout}>🚪 Logout</button>
          </div>
        </header>
        <main className="main-content">
          {children}
        </main>
      </div>
    </div>
  );
}

function AppContent() {
  return (
    <Routes>
      <Route path="/"         element={<LandingPage />} />
      <Route path="/cv/login" element={<AdminLogin />} />
      <Route path="/cv/*"     element={<CvDashboardLayout />} />

      <Route path="/proposal/login" element={<ProposalLogin />} />

      <Route path="/proposal" element={
        <ProposalProtectedRoute>
          <ProposalDashboardLayout>
            <ProposalPage />
          </ProposalDashboardLayout>
        </ProposalProtectedRoute>
      } />

      <Route path="/proposal/change-password" element={
        <ProposalProtectedRoute>
          <ProposalDashboardLayout>
            <ProposalChangePassword />
          </ProposalDashboardLayout>
        </ProposalProtectedRoute>
      } />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <Router>
        <AppContent />
      </Router>
    </AuthProvider>
  );
}